/**
 * General UI components (modals, tabs, accordions).
 */

// Download Artworks: extra px so .bts-resources sits a little higher under the header.
// Increase this number to move the section up; decrease to move it down.
const RESOURCES_SCROLL_EXTRA_OFFSET = 24;

function getHeaderBottom() {
	const header = document.querySelector( 'header' );

	if ( ! header ) {
		return 0;
	}

	return Math.ceil( header.getBoundingClientRect().bottom );
}

function scrollToResourcesSection( behavior ) {
	const section = document.querySelector( '.bts-resources' );

	if ( ! section ) {
		return;
	}

	const top = window.scrollY + section.getBoundingClientRect().top - getHeaderBottom() - RESOURCES_SCROLL_EXTRA_OFFSET;

	window.scrollTo( {
		top: Math.max( 0, top ),
		behavior,
	} );
}

function triggerPostersTab() {
	const tabButton = document.getElementById( 'bts-resources-37bdf14-tab-posters' );

	if ( tabButton ) {
		tabButton.click();
	}

	scrollToResourcesSection( 'smooth' );
	[ 400, 800, 1400, 2200 ].forEach( ( delay ) => {
		window.setTimeout( () => scrollToResourcesSection( 'auto' ), delay );
	} );
}

function initResourcesPostersTab() {
	const footerLink = document.querySelector( '.link-resource a' );

	if ( footerLink ) {
		footerLink.addEventListener( 'click', function ( e ) {
			if ( window.location.pathname.includes( '/resources/' ) ) {
				e.preventDefault();
				triggerPostersTab();
				history.pushState( null, null, '#posters' );
			}
		} );
	}

	const activateFromHash = () => {
		if ( window.location.hash === '#posters' ) {
			setTimeout( triggerPostersTab, 500 );
		}
	};

	if ( document.readyState === 'complete' ) {
		activateFromHash();
	} else {
		window.addEventListener( 'load', activateFromHash, { once: true } );
	}
}

export default function initUi() {
	initResourcesPostersTab();
}
